import core from "@/helpers/client";

const teamLineService = {
  async headteamMasterAsync(params) {
    const result = await core.head(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/teams`,
      params
    );
    return result;
  },
  async getteamMasterListAsync(params) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/teams`,
      params
    );
    return result;
  },
  async getteamMasterDetailAsync(id) {
    const result = await core.fetch(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/teams/${id}`
    );
    return result;
  },
  async createteamMasterAsync(model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/teams`,
      model
    );
    return result;
  },
  async createteamUserAsync(id, model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/teams/${id}/users`,
      model
    );
    return result;
  }, 
  async createGroupUserTeamAsync(id, model) {
    const result = await core.create(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/teams/${id}/groups`,
      model
    );
    return result;
  },
  async updateteamMasterAsync(id, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/teams/${id}`,
      model
    );
    return result;
  },
  async updateGroupUserTeamAsync(id,group, model) {
    const result = await core.update(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/teams/${id}/groups/${group}`,
      model
    );
    return result;
  },
  async deleteteamUserByIdAsync(id,openId) {
    const result = await core.delete(
      `${process.env.VUE_APP_BASE_URL_PROFILE}api/v1/teams/${id}/users/${openId}`,
    );
    return result;
  },
};
export default teamLineService;
